import request from "../utils/http";
import axios from "axios";

/**
 * 项目配置
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */

export  function ProConfigList(data) {
  return  request(
    {
      url:'/system/getProConfig',
      method: 'post',
      data:data,
    }
  )
}


/**
 * 枚举列表
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export  function GetEnumList(data) {
  return  request(
    {
      url:'/system/getEnumList',
      method: 'post',
      data:data,
    }
  )
}
/**
 * 修改项目配置数据
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export  function UpdateEnumList(data) {
  return  request(
    {
      url:'/system/updateEnumData',
      method: 'post',
      data:data,
    }
  )
}

/**
 * 修改项目配置数据
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export  function AddActiveColumnData(data) {
  return  request(
    {
      url:'/system/addDataForm',
      method: 'post',
      data:data,
    }
  )
}

/**
 * 修改项目配置数据
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export  function GetFormColumnList(data) {
  return  request(
    {
      url:'/system/queryFormColumnList',
      method: 'post',
      data:data,
    }
  )
}
/**
 * 修改项目配置数据
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export  function UpdateViewField(data) {
  return  request(
    {
      url:'/system/updateViewField',
      method: 'post',
      data:data,
    }
  )
}

/**
 * 问题列表
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export  function getProblemList(data) {
  return  request(
    {
      url:'/system/getProblemList',
      method: 'post',
      data:data,
    }
  )
}
/**
 * 新建问题
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export  function addProblem(data) {
  return  request(
    {
      url:'/system/addProblem',
      method: 'post',
      data:data,
    }
  )}
/**
 * 修改
 */
export  function updateProblem(data) {
  return  request(
    {
      url:'/system/updateProblem',
      method: 'post',
      data:data,
    }
  )
}
/**
 * 删除
 */
export  function deleteProblem(data) {
  return  request(
    {
      url:'/system/deleteProblem',
      method: 'post',
      data:data,
    }
  )
}
